import * as React from "react";
import { useCallback } from "react";
import { PATIENT_DOMAIN, PATIENT_LIST_ENDPOINT } from "api/patientApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notificationApi } from "api/notificationApi";
import Button from "@mui/joy/Button";
import { theme } from "styles/theme";

export default function PatientRemindDoneButton({
  patientId,
  onAfterAction,
}: {
  patientId: number;
  onAfterAction: () => void;
}) {
  const queryClient = useQueryClient();

  const sendNotificationQueryFn = useCallback(
    () => notificationApi.done(patientId),
    [patientId]
  );

  const { mutate: remind } = useMutation(sendNotificationQueryFn, {
    onSuccess: () => {
      queryClient.invalidateQueries([PATIENT_DOMAIN, PATIENT_LIST_ENDPOINT]);
    },
  });

  return (
    <Button
      size="sm"
      variant="Plain"
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        onAfterAction();
        remind();
      }}
      sx={{
        width: "100%",
        height: "44px",
        fontSize: "14px",
        fontWeight: 500,
        px: "20px",
        justifyContent: "flex-start",
        color: theme.vars.palette.Content.Strong,
        backgroundColor: theme.vars.palette.Surface.Forward,
      }}
    >
      {"리마인드 제외"}
    </Button>
  );
}
